import api from './api';
// All endpoints below are relative to the axios baseURL which resolves to /api in production

// Get all products (public)
const getProducts = async (filters = {}) => {
  const queryString = new URLSearchParams(filters).toString();
  const response = await api.get(`/products?${queryString}`);
  return response.data;
};

// Get wholesaler's own products
const getMyProducts = async () => {
  const response = await api.get('/products/mine');
  return response.data;
};

// Get single product
const getProduct = async (id) => {
  const response = await api.get(`/products/${id}`);
  return response.data;
};

// Create product (WHS only)
const createProduct = async (productData) => {
  const response = await api.post('/products', productData);
  return response.data;
};

// Update product (WHS only)
const updateProduct = async (id, productData) => {
  const response = await api.put(`/products/${id}`, productData);
  return response.data;
};

// Toggle product activation
const toggleProductActivation = async (id) => {
  const response = await api.patch(`/products/${id}/activation`);
  return response.data;
};

// Delete product (WHS only)
const deleteProduct = async (id) => {
  const response = await api.delete(`/products/${id}`);
  return response.data;
};

const productService = {
  getProducts,
  getMyProducts,
  getProduct,
  createProduct,
  updateProduct,
  toggleProductActivation,
  deleteProduct,
};

export default productService;